<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div
            class="d-flex justify-content-between align-items-center flex-md-row flex-column"
          >
            <div>
              <bita-bootbutton
                type="primary"
                title="افزودن تراکنش"
                icon="fas fa-plus-square"
                btn-width="250px"
                @click.native="createWallets"
              />
              <bita-bootbutton
                type="primary"
                title="کاهش اعتبار"
                icon="fas fa-minus-square"
                btn-width="250px"
                class="mr-0 mr-md-3 mt-md-0 mt-3"
                @click.native="statusChangeModalCreditReduction"
              />
            </div>

            <bita-input
              type="text"
              name="search"
              label="جستجو"
              rules=""
              validation-container-class="col-12 col-md-2"
              input-class="form-control"
              v-model.lazy="search"
              @change="(e) => searchUser(e)"
            />
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :howRow="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="createModal"
      :props-data="editForm"
      :props-permissions="permission"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن تراکنش"
      @on-submit="handleCreate"
    />
    <credit-reduction
      ref="editModal"
      :isLoading="isLoadingModal"
      modal-id="credit-reduction"
      title="کاهش اعتبار راننده"
      @on-submit="handleCreditReduction"
    />
  </div>
</template>
<script>
import transaction from "./Form.vue";
import creditReduction from "./components/CreditReductionForm.vue";
export default {
  components: { "form-modal": transaction, creditReduction },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "ابزار مدیریت", link: "" },
        {
          title: "مدیریت کیف پول",
          link: "/manage/wallet",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      role: {
        name: "",
        permissions: [],
      },
      pageSize: 30,
      currentPage: 1,
      search: "",
      permission: {},
      editForm: { asfas: "asfasf" },
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: 40 },
        { field: "user.full_name", title: "نام و نام خانوادگی" },
        {
          field: "amount",
          title: "مبلغ",
          template: (e) =>
            e.amount ? `${this.$thousandSeprator(e.amount)}` : " - ",
          width: "100px",
        },
        {
          field: "gateway_transaction.ref_id",
          title: "آتوریتی",
          width: "100px",
        },
        {
          field: "gateway_transaction.tracking_code",
          title: "شناسه ارجاع",
          width: "100px",
        },
        { field: "user.national_code", title: "کدملی", width: 150 },
        { field: "gateway_transaction.ref_id", title: "آتوریتی" },
        { field: "gateway_transaction.tracking_code", title: "شناسه ارجاع" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
      ];
    },
  },
  mounted() {},
  methods: {
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let url = `wallets/fix?search=${this.search}&page=${this.currentPage}&page_size=${this.pageSize}`;
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    statusChangeModalCreditReduction() {
      this.$toggleModal("#credit-reduction");
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createWallets() {
      this.editForm = {};
      this.statusChangeModalCreate();
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        ref_id: e.ref_id,
        tracking_code: e.tracking_code,
      };
      this.$persistClient("post", "wallets/fix", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalCreate();
        });
    },
    handleCreditReduction(e) {
      this.isLoadingModal = true;

      let data = {
        user_id: e.user_id,
        description: e.description,
        price: e.price,
      };

      this.$persistClient("post", `wallets/reduction`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
        })
        .finally(() => {
          this.isLoadingModal = false;
          this.statusChangeModalCreditReduction();
        });
    },
    searchUser: _.debounce(function() {
      this.loadData();
    }, 1000),
  },
};
</script>
